/**
 * Sanitizes a recipe name by replacing any invalid characters with hyphens
 *
 * @param name The recipe name to sanitize
 * @returns The sanitized recipe name with only allowed characters
 */
export const sanitizeRecipeName = (name: string): string => {
  // Replace any character that isn't a-z, A-Z, 0-9, space, dot, underscore, or hyphen with a hyphen
  return name.replace(/[^a-zA-Z0-9 _.-]/g, '-');
};

/**
 * Validates a recipe name and returns a boolean indicating if it's valid
 *
 * @param name The recipe name to validate
 * @returns Boolean indicating if the name is valid
 */
export const validateRecipeName = (name: string): boolean => {
  // Only allow letters, numbers, spaces, hyphens, dots, and underscores
  const validNameRegex = /^[a-zA-Z0-9 _.-]+$/;
  return validNameRegex.test(name);
};
